import { Controller } from "react-hook-form";

import { Select } from "@components/v2";
import { Label } from "@components/v2/typography/label";
import { useScheduleExportFormContext } from "@features/data-export-v2/hooks/useScheduleExportFormContext";
import { dynamicPeriodTypesOptions } from "@features/data-export-v2/report-data/period-schema";

import { ScheduledExportHeader } from "../components/scheduled-export-form/scheduled-export-header";

export const ReportDataForm = () => {
  const scheduleExportForm = useScheduleExportFormContext();

  const reportType = scheduleExportForm.watch("reportData.type");

  return (
    <>
      <ScheduledExportHeader
        title="Report type"
        description="Select the report type you want to export."
      />
      <div className="flex flex-col gap-4 mt-4">
        <Label label="Report type" variant={300} className="w-1/2 max-w-sm">
          <Controller
            name="reportData.type"
            control={scheduleExportForm.control}
            render={({ field }) => (
              <Select
                size="md"
                value={field.value}
                options={[{ value: "TOUCHPOINTS", label: "Touchpoints" }]}
                onChange={field.onChange}
                buttonClassName="w-full"
              />
            )}
          />
        </Label>
        {reportType === "TOUCHPOINTS" && (
          <Label label="Period" variant={300} className="w-1/2 max-w-sm">
            <Controller
              name="reportData.period.type"
              control={scheduleExportForm.control}
              render={({ field }) => (
                <Select
                  size="md"
                  value={field.value}
                  options={dynamicPeriodTypesOptions}
                  onChange={field.onChange}
                  buttonClassName="w-full"
                />
              )}
            />
          </Label>
        )}
      </div>
    </>
  );
};
